import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { SETTINGS_ROUTES } from "@src/routes/routes";

import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "../../store/slices/global";

export const FreeTrialDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector(isDialogOpen("freeTrial"));
  const { isPersonalization } = useSelector(getDialogPropDetails("freeTrial"));
  const handleDialogClose = () => {
    dispatch(setDialog({ dialog: "freeTrial", open: false }));
  };

  const title = "Billing Approval Required";

  const subtitle = (
    <IgTypography>
      You are currently on a free trial. You can set up your{" "}
      {isPersonalization ? "Experience" : "test"}, but it won't be available to
      launch until you upgrade your plan.
    </IgTypography>
  );
  return (
    <IgDialog
      showDialog={isOpen}
      title={title}
      handleClose={handleDialogClose}
      rawContent={subtitle}
      yesButtonText={"Go To Billing"}
      noButtonText={"Close"}
      handleNoClick={handleDialogClose}
      handleYesClick={() => {
        void navigate(SETTINGS_ROUTES.Settings, {
          state: { targetId: "intelligems-plan" },
        });
        handleDialogClose();
      }}
    />
  );
};
